var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Components, CustomElement, Defaults, P, PCSS, PropertyConverters, Watch } from '@pacem/pacem-core';
//namespace Pacem.Components.Scaffolding {
export const CHAR_COUNTER_CHILD = `<${P}-char-count hide="{{ :host.readonly || !(:host.minlength > 0 || :host.maxlength > 0) }}" minlength="{{ :host.minlength }}" maxlength="{{ :host.maxlength }}" string="{{ :host.value }}"></${P}-char-count>`;
let PacemCharCountElement = class PacemCharCountElement extends Components.PacemElement {
    _isValid(v) {
        const l = this._length(v);
        if (this.minlength > 0 && l < this.minlength)
            return false;
        if (this.maxlength > 0 && l > this.maxlength)
            return false;
        return true;
    }
    _length(s) {
        return (s && s.length) || 0;
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemCharCountElement.prototype, "minlength", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemCharCountElement.prototype, "maxlength", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemCharCountElement.prototype, "string", void 0);
PacemCharCountElement = __decorate([
    CustomElement({
        tagName: P + '-char-count',
        shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-panel class="${PCSS}-char-count" css-class="{{ {'valid': :host._isValid(:host.string), 'invalid': !:host._isValid(:host.string) } }}">
    <${P}-span hide="{{ !(:host.minlength > 0) }}" class="${PCSS}-char-min" content="{{ :host.minlength }}"></${P}-span>
    <${P}-span class="${PCSS}-char-curr" content="{{ :host._length(:host.string) || '0' }}"></${P}-span>
    <${P}-span hide="{{ !(:host.maxlength > 0) }}" class="${PCSS}-char-max" content="{{ :host.maxlength }}"></${P}-span>
</${P}-panel>`
    })
], PacemCharCountElement);
export { PacemCharCountElement };
